export default "__VITE_ASSET__BN$Fe0bO__"